/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Annotation Portal React base styles
import colors from "assets/theme/base/colors";

// Annotation Portal React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, text } = colors;

const select = {
  // Every dropdown shows the same chevron arrow.
  defaultProps: {
    IconComponent: KeyboardArrowDownIcon,
  },

  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      // Fill the whole field so a click anywhere in the box (not just on the value) opens the
      // list. Pages that need the field to grow with its content override this.
      height: "100% !important",
      boxSizing: "border-box",
      // Right padding leaves room for the arrow so long values don't run under it.
      padding: `0 ${pxToRem(32)} 0 ${pxToRem(12)} !important`,

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "block",
      right: pxToRem(8),
      fontSize: pxToRem(20),
      color: text.main,
    },
  },
};

export default select;
